import { formatNumberToShort } from '../../helpers'

export const getCustomDataLabelsOptions = ({
  maxValue,
  fontSize = 14,
  currencySymbol = '',
  horizontalPadding = 4,
  verticalPadding = 2,
  color = 'white'
}) => {
  return {
    display: true, // Always show labels - positioning logic handles visibility
    formatter: value =>
      currencySymbol ? `${currencySymbol}${formatNumberToShort(value, 2)}` : formatNumberToShort(value, 0),
    color: color,
    borderColor: 'white',
    borderWidth: 3,
    borderRadius: 4,
    padding: {
      top: verticalPadding,
      bottom: verticalPadding,
      right: horizontalPadding,
      left: horizontalPadding
    },
    align: 'start',
    anchor: 'end',
    font: {
      size: fontSize
    }
  }
}
